import { render } from "./HouseProduct.vue?vue&type=template&id=8f808c0a"
import script from "./HouseProduct.vue?vue&type=script&lang=js"
export * from "./HouseProduct.vue?vue&type=script&lang=js"

import "./HouseProduct.vue?vue&type=style&index=0&id=8f808c0a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__